import * as React from 'react'
import { LogoWithText } from '../../components/LogoWithText'

interface DeleteAccountLayoutProps {
  title: string
  children: React.ReactNode
}

export const DeleteAccountLayout: React.FC<DeleteAccountLayoutProps> = ({ title, children }) => (
  <div className="relative flex flex-col items-center w-full min-h-dvh bg-white px-4">
    <LogoWithText className="absolute top-12" />
    <div className="flex-1 min-h-[140px]" />
    <div className="flex flex-col w-full max-w-[400px]">
      <h1 className="text-xl font-semibold text-center mb-3">{title}</h1>
      {children}
    </div>
    <div className="flex-1 min-h-[40px]" />
  </div>
)
